import { userServiceApi } from "../../api";
import { UserInfo } from "../../project/api/get-project-user";

export const findUserById = (userId: string): Promise<UserInfo> => {
  return userServiceApi
    .get(`/api/v1/users/${userId}/contacts`)
    .then((r) => r.data);
};
